module.exports = __webpack_public_path__ + "static/media/remove_line.2da4cd7c.wav";